/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Nav_PuzzlesInputs */

const en_control_nav_puzzles = /** @type {(inputs: Control_Nav_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puzzles`)
};

const zh_control_nav_puzzles = /** @type {(inputs: Control_Nav_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谜题`)
};

/**
* | output |
* | --- |
* | "Puzzles" |
*
* @param {Control_Nav_PuzzlesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_nav_puzzles = /** @type {((inputs?: Control_Nav_PuzzlesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Nav_PuzzlesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_nav_puzzles(inputs)
	return zh_control_nav_puzzles(inputs)
});
export { control_nav_puzzles as "control.nav.puzzles" }